// Copyright 2024, Imprivata, Inc.  All rights reserved.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { LocaleProvider } from './i18n';
import SetupRoutes from './setup/SetupRoutes';
import './styles/index.less';
import '@imprivata-cloud/design-system/style.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import useInit from './hooks/useInit';
import PortalRoutes from './portal/PortalRoutes';
import SelfServiceRoutes from './self-service/SelfServiceRoutes';

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);
const queryClient = new QueryClient();

// App entrypoint
const App = () => {
  useInit();
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path={'setup/*'} element={<SetupRoutes />} />
        <Route path={'self-service/*'} element={<SelfServiceRoutes />} />
        <Route path="*" element={<PortalRoutes />} />
      </Routes>
    </QueryClientProvider>
  );
};

// Render the application
root.render(
  <React.StrictMode>
    <LocaleProvider>
      <Router>
        <App />
      </Router>
    </LocaleProvider>
  </React.StrictMode>,
);
